import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslationService } from '@examsoft/translation';
import { filter, flatMap } from 'rxjs/operators';
import { esLoginService } from '@examsoft/haste-ui';
import { environment } from 'src/environments/environment';
import Cookies from 'js-cookie';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('mainContent', { static: false }) mainContent: ElementRef;
  skipToContentPath: string = '';
  constructor(
    private translationService: TranslationService,
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    if (Cookies.get('esLoginData')) {
      let token = JSON.parse(Cookies.get('esLoginData')).userData.auth;
      localStorage.setItem('portalToken', token);
    }
  }

  isReady$ = this.translationService.isReady$;

  ngOnInit() {
    esLoginService.init();

    this.translationService.initialise$();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        flatMap((event) => {
          this.skipToContentPath = `${this.router.url}#main-content`;
          const route = this.getChild(this.activatedRoute);
          return route.data;
        })
      )
      .subscribe((data: any) => {
        const title = this.translationService.get(data.title);
        this.titleService.setTitle(title);
      });
  }
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
  skipToContent(evt) {
    let url = this.router.url;
    this.skipToContentPath =
      url.substr(0, url.indexOf('#') > 0 ? url.indexOf('#') : url.length) + '#main-content';
  }
  ngAfterViewInit() {
    if (location.hash === '#main-content') {
      setTimeout(() => {
        window.scrollTo({
          top: this.mainContent.nativeElement.offsetTop,
          behavior: 'smooth',
        });
      }, 1000);
    }
  }
}
